import { VERDICTS } from "@/components/RiskBadge";

export default function RiskGauge({ score = 0, verdict = "clear", size = 190 }) {
  const v = VERDICTS[verdict] || VERDICTS.clear;
  const r = (size - 22) / 2;
  const c = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(100, score));
  const offset = c - (pct / 100) * c;

  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="rgba(255,255,255,0.07)" strokeWidth="11" />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={v.text}
          strokeWidth="11"
          strokeLinecap="round"
          strokeDasharray={c}
          strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 1s ease", filter: `drop-shadow(0 0 8px ${v.text})` }}
        />
      </svg>
      <div className="absolute flex flex-col items-center">
        <span className="font-head text-4xl font-extrabold" style={{ color: v.text }}>
          {pct}
        </span>
        <span className="eyebrow mt-1">RISK / 100</span>
      </div>
    </div>
  );
}
